import { useAuth } from '../context/AuthContext';
import { useManagerDepartments } from './useManagerDepartments';

/**
 * Hook para verificar si el usuario tiene acceso a un departamento específico
 * (ya sea por tener el rol directo o por ser manager del departamento)
 */
export function useHasDepartmentAccess() {
  const { user } = useAuth();
  const { departments: managerDepartments } = useManagerDepartments();

  const hasAccess = (department: string): boolean => {
    if (!user) return false;
    const userRoles = Array.isArray(user.roles) ? user.roles : [];
    // Verificar si tiene el rol directo
    const hasDirectRole = userRoles.some((role) => role === department);
    // Verificar si es manager del departamento
    const isManagerOfDept = managerDepartments.includes(department as any);
    return hasDirectRole || isManagerOfDept;
  };

  return { hasAccess };
}

